import { hostLabelOf } from "@/components/AgentWebsiteRow/agentWebsiteModel";
import { packageActiveFor } from "@/components/BrokeragePlan/brokeragePlanModel";
import { requestsLineOf } from "@/components/BrokerageProRequests";

export const HUB_ROWS = ["page", "agents", "website", "leads", "pro", "editors"];

export const ROW_ALIASES = {
  showcase: "website",
  setup: "website",
  billing: "website",
  routing: "leads",
  results: "leads",
  plan: "website",
  requests: "pro",
};

export const initialRowOf = (search) => {
  const params = new URLSearchParams(search || "");
  const section = params.get("section") || params.get("row");
  const tab = params.get("tab");
  if (params.get("showcase") || tab === "showcase") return "website";
  if (tab === "office") return "leads";
  if (HUB_ROWS.includes(section)) return section;
  return ROW_ALIASES[section] || null;
};

const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;

export const planActiveOf = (data, brokeragePlan) =>
  Boolean(data?.plan?.active || data?.plus?.active || packageActiveFor(brokeragePlan, data?.id));

export const checklistOf = ({ data, showcase }) => {
  const settings = data?.settings || {};
  const host = hostLabelOf(settings.website);
  return [
    { key: "page", label: "Page details and logo", done: Boolean(settings.about && (settings.logoUrl || data?.brandLogoUrl)) },
    { key: "agents", label: "Agents shown, in your order", done: (data?.agents || []).length > 0 },
    { key: "website", label: host ? `Cards on ${host}` : "Cards on your website", done: Boolean(showcase?.checklist?.live) },
    {
      key: "leads",
      label: "First website lead sent to an agent",
      done: Boolean(showcase?.checklist?.firstLead || data?.firstLeadRoutedAt),
    },
  ];
};

const MODE_LINES = {
  rotate: "Leads take turns across your agents",
  area: "By area, the ZIP codes you set",
  price: "By the buyer's budget",
  visitor: "The visitor picks the agent",
};

export const rowStatusOf = (key, { data, showcase, planActive, requests, requestsFailed, routing }) => {
  const settings = data?.settings || {};
  const host = hostLabelOf(settings.website);
  switch (key) {
    case "page":
      return settings.about
        ? [host, settings.phone].filter(Boolean).join(", ") || "About, contact, cover and logo"
        : "Add your about, website, phone and logo";
    case "agents": {
      const agents = (data?.agents || []).length;
      const order = data?.agentOrder?.mode === "custom" ? "your order" : "most active first";
      const teams = (data?.teams || []).length;
      return [plural(agents, "agent", "agents"), order, teams ? plural(teams, "team", "teams") : null].filter(Boolean).join(", ");
    }
    case "website":
      if (showcase?.checklist?.live) return `Live on ${host || "your website"}`;
      if (planActive) return `Add the code to ${host || "your website"} to go live`;
      return `Preview your agents' buyers on ${host || "your website"}`;
    case "leads":
      return MODE_LINES[routing?.mode] || MODE_LINES.rotate;
    case "pro":
      return requestsLineOf(requests, requestsFailed);
    case "editors": {
      const admins = (data?.admins || []).length;
      return admins ? plural(admins, "person can edit", "people can edit") : "Only you can edit";
    }
    default:
      return "";
  }
};
